export const TASK_TYPES = {
  email: "Email",
  sms: "SMS",
  call: "Call",
  todo: "To-do",
}

export const TASK_PRIORITY_NONE = "none"

export const TASK_PRIORITIES = {
  [TASK_PRIORITY_NONE]: "None",
  low: "Low",
  medium: "Medium",
  high: "High",
}
